import React from 'react';
import {
  PLATFORM_LIST_WITH_ALL,
  SELECTED_PLATFORM_COLOR_CODE,
  PLATFORM_ICON_CSS_CLASS
} from '../../../../config/constants';

interface LomavisPlatformIconProps {
  platform: (typeof PLATFORM_LIST_WITH_ALL)[number];
  size?: number;
}

/*
 * Component: LomavisPlatformIcon
 * This component is used to display a platform icon. The height of the icon is set to 20px. This is due to
 * the fact that YouTube's brand guidelines required at least 20px height for the icon to be displayed correctly.
 * */
export const LomavisPlatformIcon: React.FC<LomavisPlatformIconProps> = ({
  platform,
  size
}) => {
  if (!platform) {
    // nothing to show if platform is undefined/null
    return null;
  }

  const key = platform.toLowerCase();
  const iconClass = PLATFORM_ICON_CSS_CLASS[key];

  if (!iconClass) {
    // fallback in case a non-supported platform sneaks in
    return null;
  }

  return (
    <i
      className={PLATFORM_ICON_CSS_CLASS[platform.toLowerCase()]}
      style={{
        fontSize: size ?? 20,
        color: SELECTED_PLATFORM_COLOR_CODE[platform]
      }}
      title={platform}
      data-numeric-value={platform}
      role="presentation"
      aria-hidden="true"
    ></i>
  );
};
